import { render, staticRenderFns } from "./DialogUpdateProfile.vue?vue&type=template&id=bc74b390&"
import script from "./DialogUpdateProfile.vue?vue&type=script&lang=js&"
export * from "./DialogUpdateProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc74b390')) {
      api.createRecord('bc74b390', component.options)
    } else {
      api.reload('bc74b390', component.options)
    }
    module.hot.accept("./DialogUpdateProfile.vue?vue&type=template&id=bc74b390&", function () {
      api.rerender('bc74b390', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogUpdateProfile.vue"
export default component.exports